<template>
  <div class="app">
    <ToastContainer />
    <router-view v-if="!hasError" />
    <div v-else>
      <ErrorFallback />
    </div>
  </div>
</template>
<script setup>
import { ref, onErrorCaptured } from 'vue';
import ErrorFallback from '@/components/error/ErrorFallback.vue';
import * as Sentry from '@sentry/vue';
import ToastContainer from '@/components/base/toast/index.vue';

const hasError = ref(false);

onErrorCaptured((err, instance, info) => {
  Sentry.setTag('vue_component', instance?.$.type?.name || 'unknown');
  Sentry.setTag('error_info', info);

  Sentry.captureException(err, {
    level: 'error',
    extra: {
      componentName: instance?.$.type?.name,
      errorInfo: info,
      vueComponent: instance,
    },
  });
  hasError.value = true;
  return false;
});
</script>
<style lang="scss">
* {
  box-sizing: border-box !important;
}
</style>
